import React from "react";
import { Link } from "react-router-dom";
import { LucideIcon, Inbox, Plus, ArrowRight } from "lucide-react";

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  actionText?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
  actionIcon?: LucideIcon;
  secondaryActionText?: string;
  secondaryActionLabel?: string;
  secondaryActionTo?: string;
  onSecondaryAction?: () => void;
  badge?: string;
  className?: string;
  compact?: boolean;
}

export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  actionText,
  actionLabel,
  actionTo,
  onAction,
  actionIcon: ActionIcon = Plus,
  secondaryActionText,
  secondaryActionLabel,
  secondaryActionTo,
  onSecondaryAction,
  badge,
  className = "",
  compact = false
}: EmptyStateProps) {
  const primaryText = actionText || actionLabel;
  const secondaryText = secondaryActionText || secondaryActionLabel;

  return (
    <div
      className={`admin-empty-state-card ${compact ? "compact" : ""} ${className}`}
      role="status"
    >
      {/* Decorative ambient badge / glow */}
      <div className="admin-empty-icon-halo">
        <div className="admin-empty-icon-wrap">
          <Icon className="admin-empty-icon" size={compact ? 24 : 32} />
        </div>
      </div>

      {badge && (
        <span className="admin-empty-badge">
          {badge}
        </span>
      )}

      <h3 className="admin-empty-title">{title}</h3>
      <p className="admin-empty-desc">{description}</p>

      {/* Action buttons */}
      {(primaryText || secondaryText) && (
        <div className="admin-empty-actions">
          {primaryText && actionTo && (
            <Link to={actionTo} className="admin-btn-primary">
              <ActionIcon size={15} />
              <span>{primaryText}</span>
            </Link>
          )}

          {primaryText && onAction && !actionTo && (
            <button
              type="button"
              onClick={onAction}
              className="admin-btn-primary"
            >
              <ActionIcon size={15} />
              <span>{primaryText}</span>
            </button>
          )}

          {secondaryText && secondaryActionTo && (
            <Link to={secondaryActionTo} className="admin-btn-secondary">
              <span>{secondaryText}</span>
              <ArrowRight size={14} />
            </Link>
          )}

          {secondaryText && onSecondaryAction && !secondaryActionTo && (
            <button
              type="button"
              onClick={onSecondaryAction}
              className="admin-btn-secondary"
            >
              <span>{secondaryText}</span>
              <ArrowRight size={14} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
